import { Component, computed, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BankAccountProxyService } from '../../../proxies/bank-account.proxy.service';
import { BankAccount } from '../../../models/bank-account/bank-account';
import { BankStatement } from '../../../models/bank-statement/bank-statement';

@Component({
  selector: 'app-bank-statement',
  templateUrl: './bank-statement.component.html',
  styleUrl: './bank-statement.component.scss',
})
export class BankStatementComponent implements OnInit {
  bankAccounts = signal<BankAccount[]>([]);
  statement = signal<BankStatement | null>(null);
  isLoading = 0;

  totalIn = computed(() => {
    const lines = this.statement()?.lines ?? [];
    return lines.filter((l) => l.direction === 'CREDIT').reduce((s, l) => s + l.amount, 0);
  });

  totalOut = computed(() => {
    const lines = this.statement()?.lines ?? [];
    return lines.filter((l) => l.direction === 'DEBIT').reduce((s, l) => s + l.amount, 0);
  });

  filterForm = new FormGroup({
    accountId: new FormControl<string | null>(null, [Validators.required]),
    from: new FormControl<Date | null>(null, [Validators.required]),
    to: new FormControl<Date | null>(null, [Validators.required]),
  });

  constructor(private bankAccountService: BankAccountProxyService) {}

  ngOnInit(): void {
    this.loadAccounts();
  }

  private loadAccounts() {
    this.isLoading++;
    this.bankAccountService.getAll().subscribe({
      next: (response) => {
        this.bankAccounts.set(response.data ?? []);
        this.isLoading--;
      },
      error: (error) => {
        this.isLoading--;
        throw error;
      },
    });
  }

  loadStatement() {
    if (this.filterForm.invalid) {
      this.filterForm.markAllAsTouched();
      return;
    }
    const v = this.filterForm.value;
    if (!v.accountId || !v.from || !v.to) return;
    this.isLoading++;
    this.bankAccountService.getStatement(v.accountId, v.from.toISOString(), v.to.toISOString()).subscribe({
      next: (response) => {
        this.statement.set(response.data ?? null);
        this.isLoading--;
      },
      error: (error) => {
        this.isLoading--;
        throw error;
      },
    });
  }
}
